var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "cls001 cls002", on: { click: _vm.openDialog } },
        [_c("img", { attrs: { src: require("@/assets/newicons/id02.png") } })]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            size: "253px",
            visible: _vm.drawer,
            withHeader: false,
            "before-close": _vm.handleClose,
            "custom-class": "miana",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "list" },
            [
              _c("router-link", { attrs: { to: "/zxk/junbros/addSite" } }, [
                _c("img", {
                  staticStyle: { width: "16px", "margin-right": "6px" },
                  attrs: { src: require("@/assets/newicons/o01.png"), alt: "" },
                }),
                _vm._v(" 添加站点 "),
              ]),
              _c("router-link", { attrs: { to: "/zxk/junbros/codeTest" } }, [
                _c("img", {
                  staticStyle: { width: "16px", "margin-right": "6px" },
                  attrs: { src: require("@/assets/newicons/o02.png"), alt: "" },
                }),
                _vm._v(" 代码检测"),
              ]),
              _c("router-link", { attrs: { to: "/zxk/junbros/codeExplain" } }, [
                _c("img", {
                  staticStyle: { width: "16px", "margin-right": "6px" },
                  attrs: { src: require("@/assets/newicons/o03.png"), alt: "" },
                }),
                _vm._v(" 代码安装说明"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "Notice" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _vm._v(
              " 请先部署识别的js识别代码，检测是否部署成功，正确安装统计代码后，一般10分钟左右后，可以查看到相关的识别统计数据，请知晓。 "
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "cls001",
              staticStyle: { top: "183px" },
              on: { click: _vm.handleClose },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/newicons/id02.png") },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }